import { render, staticRenderFns } from "./multimapConfig.vue?vue&type=template&id=5e841868"
import script from "./multimapConfig.vue?vue&type=script&lang=js"
export * from "./multimapConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports